export default ["utm_source", "utm_medium", "utm_campaign"];
